import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataContext, icURL } from "./DataContextCopy";
import axios from "axios";
import { SurveysContext } from "./SurveysContext";
import { LoginContext } from "./LoginContextCopy";

const DeclareContext = createContext([]);

export const DeclareProvider = ({ children }) => {
  const { surveySeqno } = useContext(SurveysContext);

  useEffect(() => {
    console.log('surveySeqno changed: in DeclareContext', surveySeqno);
  }, [surveySeqno]);
  const { isLoginState } = useContext(LoginContext);
  
  // 악취민원신고등록
  const [declareData, setDeclareData] = useState({});

  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNm, setPhoneNm] = useState("");

  // 신고주소(행정동)
  const [rcAddr, setRcAddr] = useState("");
  // 악취 발생 일시
  const currentDateTime = new Date();
  currentDateTime.setHours(currentDateTime.getHours() + 9);

  const formattedDateTime = currentDateTime.toISOString().slice(0, 16);
  const [dateTime, setDateTime] = useState(formattedDateTime);

  // 추가내용
  const [additionalNotes, setAdditionalNotes] = useState("");

  // x,y좌표
  const [xcoord, setXcoord] = useState(null);
  const [ycoord, setYcoord] = useState(null);

  // 신고번호
  const [rcNum, setRcNum] = useState("");
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwdCheck, setPwdCheck] = useState("");

  const [addr, setAddr] = useState([]); //민원조회 주소
  const [positionXY, setPositionXY] = useState([]);
  const [roadY, setRoadY] = useState("y"); // y일 경우 도로명+지번
  const [positionAddr, setPositionAddr] = useState([]);

  // 주소 변환 (좌표->도로명+지번 주소)
  const posToAddr = async () => {
    if (positionXY.length > 0) {
      const baseurl = `${icURL}/api/position/posToAddr`;
      const params = {
        xpos: positionXY[0],
        ypos: positionXY[1],
        // road: roadY,
      };
      const queryString = new URLSearchParams(params).toString(); // url에 쓰기 적합한 querySting으로 return 해준다.
      const requrl = `${baseurl}?${queryString}`; // 완성된 요청 url.

      try {
        await fetch(requrl)
          .then((res) => res.json())
          .then((json) => {
            if (json.data === null) {
              alert("범위를 벗어났습니다.");
            } else {
              setAddress(json.data);
            }
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      console.error("positionXY is empty or invalid");
    }
  };

  // 주소 변환 (주소-> 좌표)
  const AddrToPos = async (address) => {
    try {
      // console.log("Received address:", address); // address 값이 제대로 전달되었는지 확인

      // address가 정의되어 있고, 공백이 아닌지 확인
      if (address && address.trim() !== "") {
        const response = await axios.get(`${icURL}/api/position/addrToPos`, {
          params: { address },
        });
        const point = response.data.data;

        if (
          point === null ||
          point.xpos === undefined ||
          point.ypos === undefined
        ) {
          alert("검색 결과가 없습니다.");
        } else {
          setPositionXY([point.xpos, point.ypos]);
          setTargetList(address);
        }
      } else {
        alert("주소를 입력해 주세요."); // 주소가 비어 있을 때 알림
      }
    } catch (error) {
      console.error("주소 변환 중 에러 발생:", error);
      alert("주소 변환 중 에러 발생. 콘솔을 확인하세요.");
    }
  };

  // 도로명 + 좌표 검색
  const [roadSearch, setRoadSearch] = useState("");
  const [roadSearchList, setRoadSearchList] = useState([]);

  const [targetDataList, setTargetDataList] = useState([]); // 타겟 리스트 데이터

  const getRoadSearchList = async () => {
    if (roadSearch) {
      try {
        const res = await axios.get(`${icURL}/api/position/search/road`, {
          params: { str: roadSearch },
        });
        if (res.data && res.data.data) {
          setRoadSearchList(res.data.data);
          const { xpos, ypos, address } = res.data.data[0];
          setPositionXY([xpos, ypos]); // 좌표 설정
          setAddress(address); // 주소 설정
        } else {
          alert("조회되는 주소 리스트가 없습니다.");
          setRoadSearchList([]);
          return [];
        }
      } catch (err) {
        console.error("도로명 리스트 받아오는 중 에러 발생: ", err);
      }
    }
    return [];
  };

  // 지번 + 좌표 검색
  const [jibunSearch, setJibunSearch] = useState("");
  const [jibunSearchList, setJibunSearchList] = useState([]);

  const getJibunSearchList = async () => {
    if (jibunSearch) {
      try {
        const res = await axios.get(`${icURL}/api/position/search/jibun`, {
          params: { str: jibunSearch },
        });
        if (res.data && res.data.data) {
          setJibunSearchList(res.data.data);
          const { xpos, ypos, address } = res.data.data[0];
          setPositionXY([xpos, ypos]); // 좌표 설정
          setAddress(address); // 주소 설정
        } else {
          alert("조회되는 주소 리스트가 없습니다.");
          setJibunSearchList([]);
        }
      } catch (err) {
        console.error("도로명 리스트 받아오는 중 에러 발생: ", err);
      }
    }
  };

  // 검색어로 주소+좌표 list
  const [targetList, setTargetList] = useState(""); // 검색어 결과로 사용할 리스트

  // 지점 선택 시 지도에 마커를 표시하고 지도 이동
  const handleSelectLocation = (xpos, ypos, selectedAddress) => {
    if (typeof xpos === "number" && typeof ypos === "number") {
      setPositionXY([xpos, ypos]);
    } else {
      console.error("Invalid coordinates:", xpos, ypos);
    }
    setAddress(selectedAddress);
    console.log(xpos, ypos, selectedAddress);
  };

  // 민원 카테고리-악취종류
  const [mwType, setMwType] = useState("none");
  const [typeOptions, setTypeOpstions] = useState([]);
  const getMwType = () => {
    axios
      .get(`${icURL}/mobile/minwon/getMinwonList`, {
        params: { category_code: "odor_type" },
      })
      .then((res) => {
        const response = res.data.data;
        const typeData = response.map((item) => ({
          name: item.category_name,
          value: item.category_value,
        }));
        setTypeOpstions([{ name: "선택해주세요", value: "none" }, ...typeData]);
        // console.log(typeOptions);
      });
  };

  // 민원 카테고리-악취강도
  const [mwField, setMwField] = useState("none");
  const [filedOptions, setFieldOpstions] = useState([]);
  const getMwField = () => {
    axios
      .get(`${icURL}/mobile/minwon/getMinwonList`, {
        params: { category_code: "odor_div" },
      })
      .then((res) => {
        const response = res.data.data;
        const fieldData = response.map((item) => ({
          name: item.category_name,
          value: item.category_value,
        }));
        setFieldOpstions([
          { name: "선택해주세요", value: "none" },
          ...fieldData,
        ]);
        // console.log(filedOptions);
      });
  };
  // 개인정보 동의
  const [agree, setAgree] = useState("yes");

  // 주소 이동 시에만 posToAddr() 호출
  useEffect(() => {
    if (searchType === 2 && positionXY.length > 0) {
      {
        posToAddr();
      }
    }
  }, [positionXY]);

  useEffect(() => {
    getMwField();
    getMwType();
  }, [isLoginState]);

  //주소검색 / 지도검색
  const [searchType, setSearchType] = useState(0);

  // base64 인코딩
  const encodeBase64 = (text) => {
    return btoa(unescape(encodeURIComponent(text)));
  };

  const handleSubmit = async () => {
    // 필수 항목 체크
    if (
      !address ||
      !dateTime ||
      !mwField ||
      !mwType ||
      !additionalNotes ||
      !pwdCheck
    ) {
      alert("* 필수 항목입니다. 모두 입력하여 주세요.");
      return;
    }

    // 개인정보 동의에 따른 추가 검증
    if (agree === "yes" && (!name || !phoneNm)) {
      alert("* 개인정보 동의 시 이름과 휴대폰 번호를 입력하여 주세요.");
      return;
    }

    // 동의 여부에 따른 데이터 처리
    // const nameToSend = agree === "yes" ? name : null;
    // const phoneNmToSend = agree === "yes" ? phoneNm : null;

    if (!handleNotesValidation()) {
      return;
    }
    try {
      const encoInsertName = encodeBase64(name);
      const encoInsertPhone = encodeBase64(phoneNm);
      const encoInsertPwd = encodeBase64(pwdCheck);

      const declareResponse = await fetch(`${icURL}/mobile/minwon/insert`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Content-Security-Policy": " frame-ancestors 'none'",
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
        },
        body: JSON.stringify({
          rpt_nm: encoInsertName,
          rpt_addr: address,
          rpt_call: encoInsertPhone,
          rcpt_date: dateTime.replaceAll("T", " "),
          odor_div: mwField, //강도
          mw_typ: mwType, //종류mw_typ
          rpt_ctnt: additionalNotes,
          xpos: xcoord,
          ypos: ycoord,
          rpt_password: encoInsertPwd,
          rpt_num: rcNum,
          rcpt_addr: rcAddr,
        }),
      });

      if (declareResponse.ok) {
        const responseData = await declareResponse.json();
        setDeclareData(declareData);
        setName(responseData.rpt_nm);
        setAddress(responseData.rpt_addr);
        setPhoneNm(responseData.rpt_call);
        setDateTime(responseData.rcpt_date);
        setMwField(responseData.div_name);
        setMwType(responseData.type_name);
        setAdditionalNotes(responseData.rpt_ctnt);
        setXcoord(responseData.xpos);
        setYcoord(responseData.ypos);
        setRcNum(responseData.rcNum);
        setRcAddr(responseData.rcAddr);

        alert("민원글이 등록되었습니다.");
        navigate("/survey", {
          state: { seqno: surveySeqno },
        });
        // window.location.reload();
        // console.log(responseData.reportDateTime);
      } else {
        console.error("Error fetching data:", declareResponse.statusText);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };
  const handleNotesValidation = () => {
    if (additionalNotes.length > 500) {
      // 에러 메시지를 띄우는 방법 (예: alert, 모달, 혹은 다른 사용자 정의 방법)
      alert("500자를 초과할 수 없습니다.");
      return false;
    }
    return true;
  };

  return (
    <DeclareContext.Provider
      value={{
        addr,
        setAddr,
        positionXY,
        setPositionXY,
        positionAddr,
        setPositionAddr,
        posToAddr,
        AddrToPos,

        targetList,
        setTargetList,
        handleSelectLocation,

        targetDataList,
        setTargetDataList,

        declareData,
        name,
        setName,
        address,
        setAddress,
        phoneNm,
        setPhoneNm,
        dateTime,
        setDateTime,
        additionalNotes,
        setAdditionalNotes,
        xcoord,
        setXcoord,
        ycoord,
        setYcoord,
        handleSubmit,

        // 악취목록관련
        mwField,
        setMwField,
        filedOptions,
        setFieldOpstions,

        mwType,
        setMwType,
        typeOptions,
        setTypeOpstions,

        //등록시 사용자 비밀번호 체크
        pwdCheck,
        setPwdCheck,
        pwd,
        setPwd,

        agree,
        setAgree,

        searchType,
        setSearchType,

        // 도로명 / 지번
        roadSearch,
        setRoadSearch,
        roadSearchList,
        setRoadSearchList,
        getJibunSearchList,
        jibunSearch,
        setJibunSearch,
        jibunSearchList,
        setJibunSearchList,
        getRoadSearchList,
      }}
    >
      {children}
    </DeclareContext.Provider>
  );
};

export default DeclareContext;
